import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @file Drawer
 * @author alfielv
 */
import _ from 'lodash';
import React, { useMemo, useRef } from 'react';
import { Drawer as SPAUIDrawer } from '@tencent/spaui';
import classnames from 'classnames';
import { PREFIX_CLS } from '../../constants';
import message from '../Message';
import './index.css';
var prefixCls = "".concat(PREFIX_CLS, "-drawer");
;

var Drawer = function Drawer(props) {
  var dialogOptions = props.dialogOptions,
      show = props.show,
      hideDialog = props.hideDialog;
  var config = dialogOptions.config,
      body = dialogOptions.body,
      payload = dialogOptions.payload,
      onSuccess = dialogOptions.onSuccess,
      onCancel = dialogOptions.onCancel,
      wrappedComponent = dialogOptions.wrappedComponent,
      content = dialogOptions.content,
      _dialogOptions$closeB = dialogOptions.closeBySuccess,
      closeBySuccess = _dialogOptions$closeB === void 0 ? true : _dialogOptions$closeB;

  var subTitle = config.subTitle,
      onSubmitFromConfig = config.onSubmit,
      onCancelFromConfig = config.onCancel,
      onCloseFormConfig = config.onClose,
      drawerProps = _objectWithoutProperties(config, ["subTitle", "onSubmit", "onCancel", "onClose"]);

  var mainRef = useRef(null); // 主体区域ref

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref2, wrappendSubmitCb;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              onSubmitFromConfig === null || onSubmitFromConfig === void 0 ? void 0 : onSubmitFromConfig(); // WrappedComponent内部抛出

              _ref2 = mainRef.current || {}, wrappendSubmitCb = _ref2.onSubmit;
              _context.next = 5;
              return wrappendSubmitCb === null || wrappendSubmitCb === void 0 ? void 0 : wrappendSubmitCb();

            case 5:
              _context.t0 = onSuccess;

              if (!_context.t0) {
                _context.next = 9;
                break;
              }

              _context.next = 9;
              return onSuccess();

            case 9:
              closeBySuccess && hideDialog();
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t1 = _context["catch"](0);

              if (_context.t1 !== null && _context.t1 !== void 0 && _context.t1.message) {
                message.error(_context.t1.message);
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleCancel = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref4, wrappendCancelCb;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              onCancelFromConfig === null || onCancelFromConfig === void 0 ? void 0 : onCancelFromConfig(); // WrappedComponent内部抛出

              _ref4 = mainRef.current || {}, wrappendCancelCb = _ref4.onCancel;
              _context2.next = 4;
              return wrappendCancelCb === null || wrappendCancelCb === void 0 ? void 0 : wrappendCancelCb();

            case 4:
              onCancel === null || onCancel === void 0 ? void 0 : onCancel();
              hideDialog();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleCancel() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose() {
    onCloseFormConfig === null || onCloseFormConfig === void 0 ? void 0 : onCloseFormConfig();
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    hideDialog();
  };

  var main = function () {
    var _WrappedComponent$$$t, _WrappedComponent$$$t2;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    var WrappedComponent = body || wrappedComponent || content; // ForwardRef包装的组件

    if (_.isPlainObject(WrappedComponent) && WrappedComponent.render && ((_WrappedComponent$$$t = WrappedComponent.$$typeof) === null || _WrappedComponent$$$t === void 0 ? void 0 : _WrappedComponent$$$t.description) === 'react.forward_ref') {
      return /*#__PURE__*/React.createElement(WrappedComponent, {
        ref: mainRef,
        payload: payload
      });
    } // 函数组件、类组件声明
    // 组件声明的高阶包装，React.memo，以及react-redux connect（也会包裹react.memo）


    if (_.isFunction(WrappedComponent) || _.isPlainObject(WrappedComponent) && ((_WrappedComponent$$$t2 = WrappedComponent.$$typeof) === null || _WrappedComponent$$$t2 === void 0 ? void 0 : _WrappedComponent$$$t2.description) === 'react.memo') {
      return /*#__PURE__*/React.createElement(WrappedComponent, {
        payload: payload
      });
    } // 直接返回


    return WrappedComponent;
  }(); // 抽屉容器类


  var wrapperClassName = classnames(prefixCls, drawerProps.className, _defineProperty({}, "".concat(prefixCls, "--has-subtitle"), !!subTitle)); // 副标题区

  var subTitleComponent = useMemo(function () {
    if (_.isArray(subTitle)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, _.map(subTitle, function (item) {
        return /*#__PURE__*/React.createElement("span", {
          key: /*#__PURE__*/React.isValidElement(item) ? item.key : item,
          className: "".concat(prefixCls, "-sub-text")
        }, item);
      }));
    }

    return subTitle;
  }, [subTitle]);
  return /*#__PURE__*/React.createElement(SPAUIDrawer, _extends({
    show: show,
    maskVisible: true,
    maskClosable: true,
    onClose: handleClose,
    onSubmit: handleSubmit,
    onCancel: handleCancel,
    hideFooter: true,
    headerContent: subTitleComponent
  }, drawerProps, {
    className: wrapperClassName
  }), main);
};

export default Drawer;